export default "__VITE_ASSET__Bx9dfayx__"